module.exports = __webpack_public_path__ + "static/img/expressway-text-3.14692e43.png";